<template>
  <div>
    <d-container fluid class="main-content-container px-4" v-if="airport">
      <div class="page-header row no-gutters py-4">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Airports</span>
          <h3 class="page-title">{{airport.localizedName}}</h3>
        </div>
      </div>

      <d-row>
        <d-col lg="12">
          <d-card class="card-small">
            <d-card-body>
              <d-row>
                <d-col lg="9">
                  <div class="form-group">
                    <label for="name">IATA airport code</label>
                    <d-input id="name" v-model="airport.iata" :class="{ 'is-invalid': hasError('iata') }" />
                    <span class="invalid-feedback" v-if="hasError('iata')">{{ getError('iata') }}</span>
                  </div>

                  <d-row class="mb-2">
                    <d-col>
                      <v-multi-language label="Name" v-model="airport.name" :class="{ 'is-invalid': hasError('name') }" />
                      <span class="invalid-feedback" v-if="hasError('name')">{{ getError('name') }}</span>
                    </d-col>
                  </d-row>

                  <template v-for="(terminal, i) in airport.terminals">
                    <div class="form-group" :key="'terminal-' + i">
                      <label for="name">Terminal name</label>

                      <d-input-group>
                        <d-input v-model="airport.terminals[i].name" :class="{ 'is-invalid': hasError('terminal.' + i + '.name') }" />

                        <d-input-group-addon append>
                          <d-button class="btn-white" @click="onRemoveTerminal(i)">-</d-button>
                        </d-input-group-addon>

                        <d-input-group-addon append v-if="i === airport.terminals.length - 1">
                          <d-button theme="primary" @click="onAddTerminal">+</d-button>
                        </d-input-group-addon>
                      </d-input-group>

                      <span class="invalid-feedback" v-if="hasError('terminal.' + i + '.name')">{{ getError('terminal.' + i + '.name') }}</span>
                    </div>
                  </template>

                  <d-row class="mb-2">
                    <d-col lg="3"><strong>Address</strong></d-col>
                    <d-col>
                      <div class="form-group">
                        <label for="street">Street</label>
                        <d-input id="street" v-model="airport.location.address.street" autocomplete="off" :class="{ 'is-invalid': hasError('address.street') }" />
                        <span class="invalid-feedback" v-if="hasError('address.street')">{{ getError('address.street') }}</span>
                      </div>

                      <d-form-row>
                        <d-col md="6" class="form-group">
                          <label for="zip_code">ZIP code</label>
                          <d-input id="zip_code" v-model="airport.location.address.zip_code" autocomplete="off" :class="{ 'is-invalid': hasError('address.zip_code') }" />
                          <span class="invalid-feedback" v-if="hasError('address.zip_code')">{{ getError('address.zip_code') }}</span>
                        </d-col>

                        <d-col md="6">
                          <label for="city">City</label>
                          <d-input id="city" v-model="airport.location.address.city" autocomplete="off" :class="{ 'is-invalid': hasError('address.city') }" />
                          <span class="invalid-feedback" v-if="hasError('address.city')">{{ getError('address.city') }}</span>
                        </d-col>
                      </d-form-row>

                      <div class="form-group">
                        <label for="country">Country</label>
                        <v-country-select id="country" v-model="airport.location.address.country" autocomplete="off" :class="{ 'is-invalid': hasError('address.country') }" />
                        <span class="invalid-feedback" v-if="hasError('address.country')">{{ getError('address.country') }}</span>
                      </div>

                    </d-col>
                  </d-row>

                  <d-row class="form-group">
                    <v-coordinates :address="airport.location.address" :latitude="airport.location.latitude" :longitude="airport.location.longitude" @changed="onGetCoordinates"></v-coordinates>
                  </d-row>

                  <d-alert theme="warning" show v-if="submitted && !success">
                    <span>Airport is NOT saved</span>
                  </d-alert>

                  <d-button theme="primary" @click="onSubmit" :disabled="submitting">Save Changes</d-button>
                  <!--<d-button theme="danger" @click="onDelete" style="margin-left: 8px;">Delete Airport</d-button>-->
                </d-col>
              </d-row>
            </d-card-body>
          </d-card>
        </d-col>
      </d-row>
    </d-container>
  </div>
</template>

<script>
export default {
  methods: {
    hasError: function (field) {
      return this.errors.find(error => error.field === field);
    },

    getError: function (field) {
      return this.errors.find(error => error.field === field).message;
    },

    onAddTerminal: function (event) {
      event.preventDefault();

      this.airport.terminals.push({ name: '' });
    },

    onRemoveTerminal: function (index) {
      event.preventDefault();

      this.airport.terminals.splice(index, 1);

      if (!this.airport.terminals.length) {
        this.airport.terminals.push({ name: '' });
      }
    },

    onGetCoordinates: function(lat, long) {
      this.airport.location.latitude = lat;
      this.airport.location.longitude = long
    },

    onDelete: async function (event) {
      event.preventDefault();

      if (confirm('Are you sure you want to delete this airport?')) {
        const data = await this.$apollo.mutate({
          mutation: require('../../graphql/DeleteAirport.gql'),
          variables: {
            id: this.airport.id,
          },
        });

        if (!data.data.deleteAirport.success) {
          alert('Something went wrong with deleting the airport');
        } else {
          this.$router.push({
            name: 'airports.overview',
          });
        }
      }
    },

    onSubmit: async function (event) {
      event.preventDefault();

      const terminals = [];
      const name = [];

      this.airport.terminals.forEach(terminal => {
        if (!terminal.name.length) {
          return;
        }

        terminals.push({
          name: terminal.name,
          id: terminal.id || undefined,
        });
      });

      Object.entries(this.airport.name).forEach(([language, text]) => {
        if (!text.length) {
          return;
        }

        name.push({
          language: language,
          text: text,
        });
      });

      this.submitting = true;
      this.submitted = false;
      this.errors = [];

      const data = await this.$apollo.mutate({
        mutation: require('../../graphql/UpdateAirport.gql'),
        variables: {
          id: this.airport.id,
          iata: this.airport.iata,
          name: name,
          terminals: terminals,
          location: {
            address: {
              street: this.airport.location.address.street,
              zipCode: this.airport.location.address.zip_code,
              city: this.airport.location.address.city,
              country: this.airport.location.address.country,
            },
            latitude: this.airport.location.latitude,
            longitude: this.airport.location.longitude,
          },
        },
      });

      this.submitting = false;
      this.submitted = true;
      this.success = data.data.updateAirport.success;

      if (!this.success) {
        this.errors = data.data.updateAirport.errors;
      } else {
        window.location.reload(true);
      }
    },
  },
  apollo: {
    load: function () {
      return {
        fetchPolicy: 'no-cache',
        variables: {
          airport: this.$route.params.id,
        },
        update: function (data) {
          this.airport = data.airport;
          this.airport.terminals = this.airport.terminals.length > 0 ? this.airport.terminals : [{ name: '' }];
        },
        query: require('../../graphql/GetSingleAirport.gql'),
      };
    },
  },
  data: function () {
    return {
      submitting: false,
      submitted: false,
      airport: undefined,
      success: false,
      errors: [],
    };
  },
};
</script>
